import { EntryEdit } from './edit';
import { EntryList } from './list';

export default class Entry {
  static List = EntryList;
  static Edit = EntryEdit;
}
